export default {
  translation: {
    nav: {
      home: 'Strona główna',
      trips: 'Wycieczki',
      aboutUs: 'O nas',
      alerts: 'Powiadomienia',
      wishlist: 'Ulubione',
      language: 'Język',
      profile: 'Profil',
      settings: 'Ustawienia',
      signIn: 'Zaloguj się',
      signUp: 'Zarejestruj się'
    },
    hero: {
      title: 'Odkryj Ugandę',
      subtitle: 'i nie tylko',
      description: 'Odkryj Perłę Afryki z doświadczonymi lokalnymi przewodnikami. Niezapomniane doświadczenia czekają w zapierających dech w piersiach krajobrazach i tętniącej życiem kulturze Ugandy.',
      searchPlaceholder: 'Dokąd chcesz pojechać?',
      categories: {
        all: 'Wszystkie',
        wildlife: 'Dzikie zwierzęta',
        safari: 'Safari',
        cultural: 'Kultura',
        adventure: 'Przygoda',
        birding: 'Obserwacja ptaków'
      }
    },
    common: {
      from: 'od',
      reviews: 'opinii',
      viewMore: 'Zobacz więcej',
      book: 'Zarezerwuj',
      seeAll: 'Zobacz wszystkie',
      loading: 'Ładowanie...'
    }
  }
};